<!-- <div nz-row nzType="flex" nzJustify="center" class="section-row" style="padding-top: 6px;">
  <div class="tabs-wrapper">
      <a *ngFor="let tab of tabs; let i = index;" class="tab-button" [ngClass]="{ 'active': i === selectedTab, 'disabled': tab.disabled }" (click)="tab.disabled ? null : selectTab(i)">{{ tab.displayValue }}</a>
  </div>
</div> -->


<nz-tabset
[(nzSelectedIndex)]="selectedTab"
>
<nz-tab
  *ngFor="let tab of tabs; let i = index;"
  [nzTitle]="tab.displayValue"
  (nzSelect)="tab.disabled ? null : selectTab(i)">
</nz-tab>
</nz-tabset>